// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewAgentContainer_Aqg9h {
  display: flex;
  width: 100%;
  position: relative;
  padding: 0 20px;
  background: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 50px);

  h3 {
    color: var(--_10a37f-background);
  }

  p {
    color: var(--_18181b-color);
    font-size: 10px;
    font-weight: 400;
    margin: 0;
    padding: 0;
  }

  .subTitle_EgE8i {
    color: var(--_18181b-color);
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
    margin-top: 0;
  }

  span {
    font-size: 14px;
    color: var(--_b4-color);
    font-weight: 300;
    padding: 0;
    margin: 0;
  }
  .labelName_EYUJ9{
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 5px;
    margin-top: 0;
    color: var(--_18181b-color) !important;
    /* background-color: red; */
  }
  .textareaEditableInput_uJQv3::placeholder{
    color: var(--_75-color); 
    /* color: red ; */
    font-weight: 500;
    
  }
  .textareaEditableInput_uJQv3{
    display: flex
    ;
        gap: 5px;
        color: var(--black-color);
        -webkit-user-select: none;
                user-select: none;
        font-family: "Inter", sans-serif;
        

        
  }
  .leftSide_pAwrO {
    height: 100%;
    width: 100%;
    max-width: 300px;

    @media (width<=768px) {
      max-width: 80%;
    }
  }

  @media (width<=768px) {
    flex-direction: column;
    align-items: center;
  }
}



.infoAgentSection_KLmph {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
  overflow-y: auto;
  height: calc(100vh - 80px);
  position: relative;
}


.typeContact_F9SOw {
  display: flex;
  background-color: var(--f3-background);
  border-radius: 6px;
  padding: 6px;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
}

.typeContact_F9SOw button {
  background-color: transparent;
  cursor: pointer;
  color: var(--_b4-color);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  border-radius: 8px;
  border: 1px solid transparent !important;
  flex: 1 1;
  height: 40px;
  max-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  .typeIcon_ZmCfV {
    color: var(--_b4-color);
    fill: var(--_b4-color);
    height: 20px;
    width: 20px;
  }
}

.typeContact_F9SOw .selected_J3QBL {
  background-color: var(--white-background);
  color: var(--_0d-color);
  border-radius: 8px;
  border: 1px solid var(--_0000002b-border) !important;
  box-shadow: 0 0 2px 0 var(--_00000008-shadow),
    0 0 0 0 var(--black-color),
    0 0 0 0 var(--black-color);

  .typeIcon_ZmCfV {
    color: var(--_0d-color);
    fill: var(--_0d-color);
  }
}

.newAgentSection_GSOcD {
  background-color: var(--white-background);
  border-radius: 8px;
  border: 1px solid var(--ececf1-background);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;

  textarea {
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    color: var(--_75-color);
    background-color: var(--f4-background);
    border-radius: 5px;
    font-family: "Inter", sans-serif;
    box-sizing: border-box;
    width: 100%;
    field-sizing: content;
    min-height: 100px !important;
    padding: 8px 4px;
    resize: none;
    field-sizing: content;
  }
}

.workspaceHeader_ZhRcD {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;

  .addContainer_iuwe2 {
    display: flex;
    align-items: center;
    gap: 10px;

    img {
      height: 40px;
      width: 40px;
      border-radius: 8px;
    }
  }

  h2 {
    color: var(--_18181b-color);
  }
}

.workspacesSearch_FXA8P {
  display: flex;
  align-items: center;
  width: fit-content;
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  color: var(--_75-color);
  background-color: var(--f4-background);
  border-radius: 5px;
  font-family: "Inter", sans-serif;
  box-sizing: border-box;
  field-sizing: content;
  min-height: 21px !important;
  padding: 8px 4px;
  position: relative;

  input {
    background-color: transparent;
    outline: none;
    border: none;

    &::placeholder {
      color: var(--_71717a-color);
    }
  }
}


.agentWorkspaceSection_Ej8vu,
.workspaceHeader_ZhRcD {
  p {
    font-size: 16px;
    color: var(--_0d-color);
    font-weight: 400;
  }
}

.agentWorkspaceSection_Ej8vu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #ebebeb;

  >div {
    display: flex;
    align-items: center;
    gap: 10px;

    img {
      height: 60px;
      width: 60px;
      border-radius: 8px;
    }

    .quantityContactsAssets_Slbny {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
}

.workspaceColumn_I9Qbu {
  >div {
    flex-direction: column;
    align-items: start;
  }
}

.listAgents_iz71H {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
}

.infoAgentSection_KLmph .tabsSection_Ndk7W {
  display: flex;
  align-items: center;
  gap: 10px;
}

.infoAgentSection_KLmph .tabsSection_Ndk7W .content_T1mQj {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}




.Knowledge_tCtxf {
  display: flex;
  flex-direction: column;
  gap: 10px;
}


@media (min-width: 768px) {
  .NewAgentContainer_Aqg9h {
    flex-direction: row;
  }

}

@media (max-width: 767px) {

  .typeContact_F9SOw {
    flex-direction: column;
  }

  .typeContact_F9SOw button {
    width: 100%;
  }
}

.chatSection_j72bu {
  height: 100%;
  width: 80%;
  margin: 0 auto;
}

.dropdown_ekxnf {
  background-color: var(--white-color);
  border: 1px solid #ccc;
  border-radius: 8px;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 999;
  max-height: 200px;
  overflow-y: auto;
}

.dropdownItem_gistp {
  padding: 8px 12px;
  cursor: pointer;
}

.dropdownItem_gistp:hover {
  background-color: var(--f0-border);
}

.dropdownAutomate_BILuC {
  .dropdownItem_gistp {
    display: flex;
    align-items: center;
    gap: 10px;

    img {
      width: 30px;
      height: 30px;
    }
  }

}

.automatesContent_MNfva {
  display: flex;
  align-items: center;
  gap: 10pxver;
}


.infoWorkspace_SfR5T {

  .optionsSwitchInfoWorkspace_HeYfh {
    display: flex;
    align-items: center;
    gap: 20px;

    >div {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      gap: 10px;
    }
  }
}

.typesPrompts_Jjge3 {
  display: flex;
  align-items: center;
  gap: 10px;

  >div {
    padding: 6px;
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 20px;
    color: var(--_6-color);
    font-weight: bold;

    svg {
      height: 30px;
      width: 30px;
      color: var(--_6-color);
      fill: var(--_6-color);

    }

    .PromptsIcon_m_COb {
      height: 20px;
      width: 20px;

    }
  }

  .selectedType_wq233 {
    color: var(--_3-color);

    svg {
      color: var(--_3-color);
      fill: var(--_3-color);

    }
  }
}

.defaultInstructionsContainer_FYgVr {
  padding: 6px;
  box-sizing: border-box;
  background-color: var(--ececf1-background);
}

.instructionsContainer_WKazm {
  background-color: var(--f4-background);
  padding: 6px;

  textarea {
    background-color: var(--white-background);
  }
}

.footerInstructions_qf2yG {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: end;
  gap: 10px;
}

.customLabel_XIh0A {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.infoCustomLabel_h9k3S {
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    width: 30%;
    border: none;
    outline: none;
    background-color: var(--f4-background);
    padding: 12px;
    box-sizing: border-box;
    font-family: "Inter", sans-serif;
  }
}

.instructionsContainer_WKazm {

 display: flex;
 gap: 10px;
 flex-wrap: wrap;
 width: 100%;
  
  .actions_Vu0WH{
    background-color: var(--white-background);
    color: var(--_67-color);
    border: 1px solid var(--_00000036-border);
    padding: 8px;
    border-radius: 20px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
    height: 20px;
    display: flex
  ;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    cursor: pointer;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/NewAgentComponent/NewAgentComponent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;;EAE1B;IACE,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,2BAA2B;EAC7B;EACA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;;EAElB;EACA;IACE;IACA;QACI,QAAQ;QACR,yBAAyB;QACzB,yBAAiB;gBAAjB,iBAAiB;QACjB,gCAAgC;;;;EAItC;EACA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;;IAEhB;MACE,cAAc;IAChB;EACF;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;;;AAIA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;;EAET;IACE,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;EACvB,kBAAkB;EAClB,oDAAoD;EACpD;;8BAE4B;;EAE5B;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;;EAEb;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,sCAAsC;IACtC,kBAAkB;IAClB,gCAAgC;IAChC,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;;EAE9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,YAAY;MACZ,WAAW;MACX,kBAAkB;IACpB;EACF;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;;EAElB;IACE,6BAA6B;IAC7B,aAAa;IACb,YAAY;;IAEZ;MACE,2BAA2B;IAC7B;EACF;AACF;;;AAGA;;EAEE;IACE,eAAe;IACf,uBAAuB;IACvB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;;EAEhC;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,YAAY;MACZ,WAAW;MACX,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;IACX;EACF;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;;;AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;AAGA;EACE;IACE,mBAAmB;EACrB;;AAEF;;AAEA;;EAEE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,WAAW;MACX,YAAY;IACd;EACF;;AAEF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;;AAGA;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;;IAET;MACE,aAAa;MACb,mBAAmB;MACnB,2BAA2B;MAC3B,SAAS;IACX;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,sBAAsB;IACtB,iBAAiB;;IAEjB;MACE,YAAY;MACZ,WAAW;MACX,sBAAsB;MACtB,qBAAqB;;IAEvB;;IAEA;MACE,YAAY;MACZ,WAAW;;IAEb;EACF;;EAEA;IACE,sBAAsB;;IAEtB;MACE,sBAAsB;MACtB,qBAAqB;;IAEvB;EACF;AACF;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,YAAY;;EAEZ;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;;EAET;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,gCAAgC;EAClC;AACF;;AAEA;;CAEC,aAAa;CACb,SAAS;CACT,eAAe;CACf,WAAW;;EAEV;IACE,yCAAyC;IACzC,uBAAuB;IACvB,yCAAyC;IACzC,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ;EACF;IACE,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[".NewAgentContainer {\n  display: flex;\n  width: 100%;\n  position: relative;\n  padding: 0 20px;\n  background: #f5f5f5;\n  overflow-y: scroll;\n  height: calc(100vh - 50px);\n\n  h3 {\n    color: var(--_10a37f-background);\n  }\n\n  p {\n    color: var(--_18181b-color);\n    font-size: 10px;\n    font-weight: 400;\n    margin: 0;\n    padding: 0;\n  }\n\n  .subTitle {\n    color: var(--_18181b-color);\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    margin-top: 0;\n  }\n\n  span {\n    font-size: 14px;\n    color: var(--_b4-color);\n    font-weight: 300;\n    padding: 0;\n    margin: 0;\n  }\n  .labelName{\n    font-size: 14px;\n    font-weight: 500;\n    margin-bottom: 5px;\n    margin-top: 0;\n    color: var(--_18181b-color) !important;\n    /* background-color: red; */\n  }\n  .textareaEditableInput::placeholder{\n    color: var(--_75-color); \n    /* color: red ; */\n    font-weight: 500;\n    \n  }\n  .textareaEditableInput{\n    display: flex\n    ;\n        gap: 5px;\n        color: var(--black-color);\n        user-select: none;\n        font-family: \"Inter\", sans-serif;\n        \n\n        \n  }\n  .leftSide {\n    height: 100%;\n    width: 100%;\n    max-width: 300px;\n\n    @media (width<=768px) {\n      max-width: 80%;\n    }\n  }\n\n  @media (width<=768px) {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n\n\n.infoAgentSection {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 20px;\n  overflow-y: auto;\n  height: calc(100vh - 80px);\n  position: relative;\n}\n\n\n.typeContact {\n  display: flex;\n  background-color: var(--f3-background);\n  border-radius: 6px;\n  padding: 6px;\n  gap: 10px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.typeContact button {\n  background-color: transparent;\n  cursor: pointer;\n  color: var(--_b4-color);\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  border-radius: 8px;\n  border: 1px solid transparent !important;\n  flex: 1;\n  height: 40px;\n  max-height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n\n  .typeIcon {\n    color: var(--_b4-color);\n    fill: var(--_b4-color);\n    height: 20px;\n    width: 20px;\n  }\n}\n\n.typeContact .selected {\n  background-color: var(--white-background);\n  color: var(--_0d-color);\n  border-radius: 8px;\n  border: 1px solid var(--_0000002b-border) !important;\n  box-shadow: 0 0 2px 0 var(--_00000008-shadow),\n    0 0 0 0 var(--black-color),\n    0 0 0 0 var(--black-color);\n\n  .typeIcon {\n    color: var(--_0d-color);\n    fill: var(--_0d-color);\n  }\n}\n\n.newAgentSection {\n  background-color: var(--white-background);\n  border-radius: 8px;\n  border: 1px solid var(--ececf1-background);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 20px;\n\n  textarea {\n    border: none;\n    outline: none;\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--_75-color);\n    background-color: var(--f4-background);\n    border-radius: 5px;\n    font-family: \"Inter\", sans-serif;\n    box-sizing: border-box;\n    width: 100%;\n    field-sizing: content;\n    min-height: 100px !important;\n    padding: 8px 4px;\n    resize: none;\n    field-sizing: content;\n  }\n}\n\n.workspaceHeader {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n\n  .addContainer {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    img {\n      height: 40px;\n      width: 40px;\n      border-radius: 8px;\n    }\n  }\n\n  h2 {\n    color: var(--_18181b-color);\n  }\n}\n\n.workspacesSearch {\n  display: flex;\n  align-items: center;\n  width: fit-content;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--_75-color);\n  background-color: var(--f4-background);\n  border-radius: 5px;\n  font-family: \"Inter\", sans-serif;\n  box-sizing: border-box;\n  field-sizing: content;\n  min-height: 21px !important;\n  padding: 8px 4px;\n  position: relative;\n\n  input {\n    background-color: transparent;\n    outline: none;\n    border: none;\n\n    &::placeholder {\n      color: var(--_71717a-color);\n    }\n  }\n}\n\n\n.agentWorkspaceSection,\n.workspaceHeader {\n  p {\n    font-size: 16px;\n    color: var(--_0d-color);\n    font-weight: 400;\n  }\n}\n\n.agentWorkspaceSection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 0;\n  border-bottom: 1px solid #ebebeb;\n\n  >div {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    img {\n      height: 60px;\n      width: 60px;\n      border-radius: 8px;\n    }\n\n    .quantityContactsAssets {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n}\n\n.workspaceColumn {\n  >div {\n    flex-direction: column;\n    align-items: start;\n  }\n}\n\n.listAgents {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.infoAgentSection .tabsSection {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.infoAgentSection .tabsSection .content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n\n\n\n.Knowledge {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n\n@media (min-width: 768px) {\n  .NewAgentContainer {\n    flex-direction: row;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .typeContact {\n    flex-direction: column;\n  }\n\n  .typeContact button {\n    width: 100%;\n  }\n}\n\n.chatSection {\n  height: 100%;\n  width: 80%;\n  margin: 0 auto;\n}\n\n.dropdown {\n  background-color: var(--white-color);\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 999;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.dropdownItem {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.dropdownItem:hover {\n  background-color: var(--f0-border);\n}\n\n.dropdownAutomate {\n  .dropdownItem {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n\n    img {\n      width: 30px;\n      height: 30px;\n    }\n  }\n\n}\n\n.automatesContent {\n  display: flex;\n  align-items: center;\n  gap: 10pxver;\n}\n\n\n.infoWorkspace {\n\n  .optionsSwitchInfoWorkspace {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n\n    >div {\n      display: flex;\n      align-items: center;\n      flex-direction: row-reverse;\n      gap: 10px;\n    }\n  }\n}\n\n.typesPrompts {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  >div {\n    padding: 6px;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 20px;\n    color: var(--_6-color);\n    font-weight: bold;\n\n    svg {\n      height: 30px;\n      width: 30px;\n      color: var(--_6-color);\n      fill: var(--_6-color);\n\n    }\n\n    .PromptsIcon {\n      height: 20px;\n      width: 20px;\n\n    }\n  }\n\n  .selectedType {\n    color: var(--_3-color);\n\n    svg {\n      color: var(--_3-color);\n      fill: var(--_3-color);\n\n    }\n  }\n}\n\n.defaultInstructionsContainer {\n  padding: 6px;\n  box-sizing: border-box;\n  background-color: var(--ececf1-background);\n}\n\n.instructionsContainer {\n  background-color: var(--f4-background);\n  padding: 6px;\n\n  textarea {\n    background-color: var(--white-background);\n  }\n}\n\n.footerInstructions {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: end;\n  gap: 10px;\n}\n\n.customLabel {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.infoCustomLabel {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n\n  input {\n    width: 30%;\n    border: none;\n    outline: none;\n    background-color: var(--f4-background);\n    padding: 12px;\n    box-sizing: border-box;\n    font-family: \"Inter\", sans-serif;\n  }\n}\n\n.instructionsContainer {\n\n display: flex;\n gap: 10px;\n flex-wrap: wrap;\n width: 100%;\n  \n  .actions{\n    background-color: var(--white-background);\n    color: var(--_67-color);\n    border: 1px solid var(--_00000036-border);\n    padding: 8px;\n    border-radius: 20px;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n    height: 20px;\n    display: flex\n  ;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NewAgentContainer": `NewAgentContainer_Aqg9h`,
	"subTitle": `subTitle_EgE8i`,
	"labelName": `labelName_EYUJ9`,
	"textareaEditableInput": `textareaEditableInput_uJQv3`,
	"leftSide": `leftSide_pAwrO`,
	"infoAgentSection": `infoAgentSection_KLmph`,
	"typeContact": `typeContact_F9SOw`,
	"typeIcon": `typeIcon_ZmCfV`,
	"selected": `selected_J3QBL`,
	"newAgentSection": `newAgentSection_GSOcD`,
	"workspaceHeader": `workspaceHeader_ZhRcD`,
	"addContainer": `addContainer_iuwe2`,
	"workspacesSearch": `workspacesSearch_FXA8P`,
	"agentWorkspaceSection": `agentWorkspaceSection_Ej8vu`,
	"quantityContactsAssets": `quantityContactsAssets_Slbny`,
	"workspaceColumn": `workspaceColumn_I9Qbu`,
	"listAgents": `listAgents_iz71H`,
	"tabsSection": `tabsSection_Ndk7W`,
	"content": `content_T1mQj`,
	"Knowledge": `Knowledge_tCtxf`,
	"chatSection": `chatSection_j72bu`,
	"dropdown": `dropdown_ekxnf`,
	"dropdownItem": `dropdownItem_gistp`,
	"dropdownAutomate": `dropdownAutomate_BILuC`,
	"automatesContent": `automatesContent_MNfva`,
	"infoWorkspace": `infoWorkspace_SfR5T`,
	"optionsSwitchInfoWorkspace": `optionsSwitchInfoWorkspace_HeYfh`,
	"typesPrompts": `typesPrompts_Jjge3`,
	"PromptsIcon": `PromptsIcon_m_COb`,
	"selectedType": `selectedType_wq233`,
	"defaultInstructionsContainer": `defaultInstructionsContainer_FYgVr`,
	"instructionsContainer": `instructionsContainer_WKazm`,
	"footerInstructions": `footerInstructions_qf2yG`,
	"customLabel": `customLabel_XIh0A`,
	"infoCustomLabel": `infoCustomLabel_h9k3S`,
	"actions": `actions_Vu0WH`
};
export default ___CSS_LOADER_EXPORT___;
